import { render } from "./ObjectLegend.vue?vue&type=template&id=4a0bc9a6"
import script from "./ObjectLegend.vue?vue&type=script&lang=js"
export * from "./ObjectLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__